/**
 * XXX: Field's submitErrors aren't cleared in some case (cf. nameservers)
 * which is probably a bug from final-form.
 * @param name field name of the error to clear
 */
export const clearSubmitError = (args, mutableState) => {
  const [name] = args;
  if (mutableState.formState.submitErrors?.[name]) {
    // eslint-disable-next-line no-param-reassign
    mutableState.formState.submitErrors[name] = undefined;
  }
};